import React from 'react';

import './loader.css';

class Loader extends React.Component {
	render (){
		return <p className='loading'>Loading...</p>;
	}
}

export default Loader;